export default function SectionHeading({ children, hint }) {
  return (
    <div className="mb-3.5">
      <h3 className="text-[14px] font-semibold text-slate-900">{children}</h3>
      {hint && <p className="mt-0.5 text-[12px] text-slate-500">{hint}</p>}
    </div>
  );
}